import React from 'react';

import { Box, BoxProps } from '@mui/material';

import { SxProp } from 'src/types/mui';

export type WatermarkProps = {
  text: string;
  imageWidth?: number;
  imageHeight?: number;
  textOffsetX?: number;
  textOffsetY?: number;
  fontSize?: BoxProps['fontSize'];
  hidden?: boolean;
};

export const Watermark: React.FC<React.PropsWithChildren<WatermarkProps>> = ({
  children,
  text,
  imageWidth = 300,
  imageHeight = 300,
  textOffsetX = 155,
  textOffsetY = 0,
  fontSize = '18',
  hidden,
}) => {
  const watermarkImage = React.useMemo(() => {
    return `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='${imageWidth}' height='${imageHeight}'><text x='${textOffsetX}' y='${textOffsetY}' dominant-baseline='middle' text-anchor='middle' transform='rotate(45 0 0)' fill='rgba(0,0,0,0.25)' font-size='${fontSize}'>${text.toUpperCase()}</text></svg>`;
  }, [fontSize, imageHeight, imageWidth, text, textOffsetX, textOffsetY]);

  return (
    <Box sx={hidden ? undefined : watermarkContainerStyle}>
      <Box
        sx={{ ...watermarkStyle, backgroundImage: `url("${watermarkImage}")` }}
        hidden={hidden}
      />
      {children}
    </Box>
  );
};

const watermarkContainerStyle: SxProp = {
  position: 'relative',
  overflow: 'hidden',
};

const watermarkStyle: SxProp = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 0,
  backgroundRepeat: 'repeat',
} satisfies SxProp;
